import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["display", "form", "input"]

    edit() {
        this.displayTarget.classList.add("hidden")
        this.formTarget.classList.remove("hidden")
        this.inputTarget.focus()
        this.inputTarget.select()
    }

    cancel() {
        this.formTarget.classList.add("hidden")
        this.displayTarget.classList.remove("hidden")
    }

    submit(event) {
        // IME変換中（日本語入力の確定など）は何もしない
        if (event.isComposing) return

        // Enter 押下で送信
        if (event.type === "keydown" && event.key === "Enter") {
            event.preventDefault()
            this.formTarget.querySelector("form").requestSubmit()
        }
        // Escape 押下でキャンセル
        if (event.type === "keydown" && event.key === "Escape") {
            event.preventDefault()
            this.cancel()
        }
    }
}
